function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8883 0.333374H7.11159C2.86492 0.333374 0.333252 2.86504 0.333252 7.11171V16.8767C0.333252 21.135 2.86492 23.6667 7.11159 23.6667H16.8766C21.1233 23.6667 23.6549 21.135 23.6549 16.8884V7.11171C23.6666 2.86504 21.1349 0.333374 16.8883 0.333374ZM11.9999 16.5267C9.50325 16.5267 7.47325 14.4967 7.47325 12C7.47325 9.50337 9.50325 7.47337 11.9999 7.47337C14.4966 7.47337 16.5266 9.50337 16.5266 12C16.5266 14.4967 14.4966 16.5267 11.9999 16.5267ZM18.9066 6.02671C18.8483 6.16671 18.7666 6.29504 18.6616 6.41171C18.5449 6.51671 18.4166 6.59837 18.2766 6.65671C18.1366 6.71504 17.9849 6.75004 17.8333 6.75004C17.5183 6.75004 17.2266 6.63337 17.0049 6.41171C16.8999 6.29504 16.8183 6.16671 16.7599 6.02671C16.7016 5.88671 16.6666 5.73504 16.6666 5.58337C16.6666 5.43171 16.7016 5.28004 16.7599 5.14004C16.8183 4.98837 16.8999 4.87171 17.0049 4.75504C17.2733 4.48671 17.6816 4.35837 18.0549 4.44004C18.1366 4.45171 18.2066 4.47504 18.2766 4.51004C18.3466 4.53337 18.4166 4.56837 18.4866 4.61504C18.5449 4.65004 18.6033 4.70837 18.6616 4.75504C18.7666 4.87171 18.8483 4.98837 18.9066 5.14004C18.9649 5.28004 18.9999 5.43171 18.9999 5.58337C18.9999 5.73504 18.9649 5.88671 18.9066 6.02671Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.9941,
  y1: 0.333374,
  x2: 12,
  y2: 31.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055445"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10F0C6",
  stopOpacity: 0
})));

function SvgInstagramTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramTwo);
export default __webpack_public_path__ + "static/media/instagramTwo.65ba30d13db4728ad4f4dbf3f98a533f.svg";
export { ForwardRef as ReactComponent };